const ThankYou = () =>{
    return(
        <h1>Thank you</h1>
    )
}

export default ThankYou